/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VideoThumbnailUrlDTO } from './videoThumbnailUrlDTO';


/**
 * A class that represents the information of a video.  Attributes:  video_id: The video ID.  title: The title of the video.  description: The description of the video.  date: The datetime when the video was uploaded in the SQL format \"YYYY-MM-DD HH:MM:SS\".  duration: The duration of the video in seconds.  offset_seconds: The starting time in seconds in which the video stream should start.  media_urls: A dictionary that contains the video URLs. the keys are the resolution of the video and the values are the URLs of the video. E.g: {\'720p\': \'https://example.com/video.mp4\', \'1080p\': \'https://example.com/video_1080p.mp4\'}  thumbnail_urls: The thumbnail URL of the video.
 */
export interface VideoInfoDTO { 
    video_id: string;
    title: string;
    description: string;
    date: string;
    duration_in_seconds: number;
    status: VideoInfoDTO.StatusEnum;
    gender: VideoInfoDTO.GenderEnum;
    available_resolutions: Array<string>;
    category_id: number | null;
    category_name: string | null;
    competition_id: number | null;
    competition_name: string | null;
    team_check_completed?: boolean;
    season_id?: number | null;
    match_date?: string | null;
    media_urls?: { [key: string]: string; } | null;
    thumbnail_urls: VideoThumbnailUrlDTO;
}
export namespace VideoInfoDTO {
    export const StatusEnum = {
        Pending: 'PENDING',
        Uploading: 'UPLOADING',
        Processing: 'PROCESSING',
        Ready: 'READY',
        Failed: 'FAILED',
        Deleted: 'DELETED',
        Archived: 'ARCHIVED',
        Retired: 'RETIRED',
        YoutubePending: 'YOUTUBE_PENDING',
        OnlyData: 'ONLY_DATA'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const GenderEnum = {
        Femenino: 'FEMENINO',
        Masculino: 'MASCULINO',
        Mixto: 'MIXTO',
        NoEspecificado: 'NO ESPECIFICADO'
    } as const;
    export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];
}


